import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ISiteDesign } from '@fi-shared/models';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiImageSize } from '@fi-shared/types';
import { FiMediaStorageService } from '@fi-shared/media-bank/fi-media-storage.service';
import { BehaviorSubject } from 'rxjs';
import { findClosest, isDefined } from '@fi-shared/utils';

@Component({
    selector: 'fi-site-design-brand-card',
    templateUrl: './fi-site-design-brand-card.component.html',
    styleUrls: ['./fi-site-design-brand-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-site-design-brand-card' },
    standalone: false,
})
export class FiSiteDesignBrandCardComponent {
    @Input() isAddSiteDesignLayout: boolean;
    @Input() siteDesign: ISiteDesign;
    @Output() onDeleteSiteDesign = new EventEmitter<number>();
    @Output() onCloneSiteDesign = new EventEmitter<number>();
    @Output() onSetSiteDesignAsDefault = new EventEmitter<number>();
    @Output() onCreateNewSiteDesign = new EventEmitter<void>();

    isSettingsMenuVisible$ = new BehaviorSubject<boolean>(false);

    constructor(
        private stateService: FiStateService,
        private mediaStorageService: FiMediaStorageService,
    ) {}

    toggleSettingsMenuVisibility(isVisible: boolean) {
        this.isSettingsMenuVisible$.next(isVisible);
    }

    getSiteDesignLogoUrl(): string {
        if (isDefined(this.siteDesign.LogoReference))
            return this.mediaStorageService.getMediaFileUrl(this.siteDesign.LogoReference, { size: FiImageSize.Logo });
    }

    getBrandColor(): string[] {
        return [
            `#${this.siteDesign.BrandingColor}`,
            `#${this.siteDesign.ContrastColor}`,
            `#${this.siteDesign.WidgetColor}`,
        ];
    }

    cloneSiteDesign() {
        this.onCloneSiteDesign.emit(this.siteDesign.Id);
    }

    setSiteDesignAsDefault() {
        this.onSetSiteDesignAsDefault.emit(this.siteDesign.Id);
    }

    deleteSiteDesign() {
        this.onDeleteSiteDesign.emit(this.siteDesign.Id);
    }

    editSiteDesign() {
        this.stateService.go(FiStateNames.OtherSettings.SiteDesign.BrandEdit, { Id: this.siteDesign.Id });
    }

    addNewSiteDesign() {
        this.onCreateNewSiteDesign.emit();
    }

    onBrandWrapperClick($event: MouseEvent) {
        if (!isDefined(findClosest($event.target as HTMLElement, '#site-design-menu-trigger'))) this.editSiteDesign();
    }
}
